import service from "@/api/service";
import { PaidTicketUserCSVGetRequest } from "@/api/analysis/paid-ticket-user-csv/request";
import { DownloadCSVResponse } from "@/api/response";

/**
 * デジタルチケットユーザーCSV出力APIをコールします。
 *
 * @param getRequest デジタルチケットユーザーCSV出力APIのリクエストボディ
 * @return response
 */
export async function get(getRequest: PaidTicketUserCSVGetRequest) {
  const response = await service.postReceiveCSV(
    "/analysis-paid-ticket-user-csv",
    getRequest
  );
  return response as DownloadCSVResponse;
}
